import { Link, usePage } from '@inertiajs/react'
import { ExternalLinkIcon } from 'lucide-react'

export function VendorTransactionsLink({ vendor, categoryId }: { vendor: string | null; categoryId?: number | null }) {
  const { url } = usePage()
  const current = new URL(url, 'http://nest.local').searchParams
  const params = new URLSearchParams({ account_id: 'all' })
  for (const key of ['financial_year', 'costs_month', 'currency']) {
    const value = current.get(key)
    if (value) params.set(key, value)
  }
  if (vendor === null) params.set('filter', 'no_vendor')
  else params.set('vendor', vendor)
  if (categoryId != null) params.set('category_id', String(categoryId))

  return (
    <Link href={`/transactions?${params}`} aria-label={`View transactions for ${vendor ?? 'Not assigned'}`}
      title={`View transactions for ${vendor ?? 'Not assigned'}`}
      className="inline-flex shrink-0 rounded text-primary hover:text-primary/80 focus-visible:outline focus-visible:outline-2"
      onClick={event => event.stopPropagation()}>
      <ExternalLinkIcon className="h-3.5 w-3.5" />
    </Link>
  )
}
